import { render, staticRenderFns } from "./Age.vue?vue&type=template&id=d515434a"
import script from "./Age.vue?vue&type=script&lang=ts"
export * from "./Age.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports